import { AxiosRequestConfig } from "axios";
import { COMMUNITY_URL } from "../util/constants";
import Community from "../interfaces/community";
import useApi from "./useApi";
import useAxios from "./useAxios";

const useApiCommunity = () => {
  const axiosInstance = useAxios();
  const { recover, getPage, register, edit, removeById } =
    useApi<Community>(COMMUNITY_URL);

  const getPagedCommunity = (config: AxiosRequestConfig) => getPage(config);
  const getCommunity = (id: number) => {
    return axiosInstance
      .get<Community>(`${COMMUNITY_URL}/${id}`)
      .then((res) => res.data);
  };
  const getMyCommunity = (token: string) => {
    return axiosInstance
      .get<Community | null>(`${COMMUNITY_URL}/mine/${token}`)
      .then((res) => res.data);
  };
  const createCommunity = (token: string, community: Community) => {
    return axiosInstance
      .post<Community>(`${COMMUNITY_URL}/${token}`, community)
      .then((res) => res.data);
  };
  const requestToJoin = (communityId: number, token: string) => {
    return axiosInstance
      .post<Community>(`${COMMUNITY_URL}/${communityId}/requests/${token}`)
      .then((res) => res.data);
  };
  const acceptRequest = (
    communityId: number,
    requesterId: number,
    ownerToken: string,
  ) => {
    return axiosInstance
      .put<Community>(
        `${COMMUNITY_URL}/${communityId}/requests/${requesterId}/accept/${ownerToken}`,
      )
      .then((res) => res.data);
  };
  const rejectRequest = (
    communityId: number,
    requesterId: number,
    ownerToken: string,
  ) => {
    return axiosInstance
      .delete<Community>(
        `${COMMUNITY_URL}/${communityId}/requests/${requesterId}/reject/${ownerToken}`,
      )
      .then((res) => res.data);
  };
  const leaveCommunity = (token: string) => {
    return axiosInstance
      .put<Community | null>(`${COMMUNITY_URL}/${token}/leave`)
      .then((res) => res.data);
  };

  return {
    recover,
    getCommunity,
    getMyCommunity,
    getPagedCommunity,
    createCommunity,
    requestToJoin,
    acceptRequest,
    rejectRequest,
    leaveCommunity,
    register,
    edit,
    removeById,
  };
};

export default useApiCommunity;
